<template>
  <div class="topic-feedback" v-bind="$attrs">
    <utd-content-feedback-dialog :feedback-title="$t(feedbackText)"
                                 feedback-class="user-feedback-link"
                                 :button-text="$t(feedbackText)"
                                 has-chat-box-icon />
  </div>
</template>

<script>
import UtdContentFeedbackDialog from '_acaSrc/components/shared/utd/UtdContentFeedbackDialog.vue';
import { USER_CONTENT_FEEDBACK } from '_acaSrc/utility/constants';

export default {
    components: {
        UtdContentFeedbackDialog
    },
    props: {
        feedbackUrl: {
            type: String
        },
        isForCalculator: {
            type: Boolean,
            default: () => false
        }
    },
    computed: {
        feedbackText() {
            return this.isForCalculator ?
                USER_CONTENT_FEEDBACK.TITLE.CALCULATOR : USER_CONTENT_FEEDBACK.TITLE.TOPIC;
        }
    }
};
</script>

<style lang="less" scoped>
@import (reference) '~_acaAssets/wkce/colors/wkce-app-styles';

.topic-feedback {
  text-align: center;
  cursor: pointer;
  width: 100%;
  height: 100%;
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  box-sizing: border-box;

  &:hover {
    background-color: @DS1-FLYOUT-TOGGLE-HOVER-BGCLR;
  }
}
</style>

<style lang="less">
@import (reference) '~_acaAssets/wkce/colors/wkce-app-styles';

.user-feedback-link {
  padding: 6px 0;
  display: block;

  &:hover {
    text-decoration: none;
  }

  .wkce-icon-chat-box {
    font-size: 18px;
    display: block;

    &::before {
      width: 18px;
      height: 16px;
    }
  }

  .expanded & {
    padding: 10px 8px 6px;
    line-height: 24px;
    text-align: center;

    .wkce-icon-chat-box {
      display: inline-block;
    }
  }
}

.topic-feedback-button {
  .ds1-utd-ellipsis-nowrap();

  .topic-feedback-button-text {
    .ds1-ph-compact();
  }
}
</style>
